import { apiClient } from '@/shared/api'

import { TCampaignDetail } from '../model/schema'

export const getCampaignDetail = async (campaignId: number) => {
  const response = await apiClient.get<TCampaignDetail>({
    endpoint: `/campaigns/${campaignId}`,
  })

  return response
}
